/*
 * File: d:\projects\AutoFiFront\src\Theme\Component\AboutUsStyled.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Thursday March 16th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday March 16th 2023 9:17:59 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import styled from "styled-components";

const AboutUsStyled = styled.div.attrs((props: any) => ({
    bgColor: props.bgColor,
    imgLeft: props.imgLeft,
    textColor: props.textColor,
    column: props.column,
}))`
    display: flex;
    flex-direction: ${props => props.column == true ? "column" : props.imgLeft ? "row-reverse" : "row"};
    height: 100%;
    width: 100%;
    // float:left;
    overflow: hidden;
    color: ${(props: any) => props.color};
    background-color: ${(props: any) => props.bgColor};
    // margin-bottom: 2rem;

@media (width < 1080px){
    flex-direction: column;
}
`;

export default AboutUsStyled;
